// A supplier row as the dashboard receives it: the supplier's own columns flattened together with
// the purchase fields off the join table (see bookings.service.ts enrichment).
export interface AssignedSupplier {
  id: number
  purchase_currency?: string | null
  purchase_price?: number | string | null
  purchase_description?: string | null
}

export interface ServiceSupplierValues {
  supplier_id: number | string
  purchase_currency: string
  purchase_price: number | string
  description: string
}

// Blank when adding, pre-filled when editing -- one modal covers both.
export const serviceSupplierInitialValues = (
  supplier?: AssignedSupplier
): ServiceSupplierValues => ({
  supplier_id: supplier?.id ?? '',
  purchase_currency: supplier?.purchase_currency ?? '',
  purchase_price: supplier?.purchase_price ?? '',
  description: supplier?.purchase_description ?? '',
})

// The assign endpoints UPDATE the join row when the same supplier is re-assigned, so the old
// assignment only needs removing when the supplier actually changed. react-select hands back
// strings, so compare loosely.
export const supplierSwapRemovalId = (
  editing: AssignedSupplier | undefined,
  chosenSupplierId: string | number
): number | null => {
  if (!editing) return null
  return Number(editing.id) === Number(chosenSupplierId) ? null : editing.id
}
